import React from 'react';
import styled from 'styled-components';

function CRTEffect({ enabled }) {
  if (!enabled) return null;
  return <CRTOverlay />;
}

const CRTOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99999;

  /* Scanlines */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
      to bottom,
      transparent 0px,
      transparent 1px,
      rgba(0, 0, 0, 0.06) 1px,
      rgba(0, 0, 0, 0.06) 2px
    );
    pointer-events: none;
    z-index: 1;
  }

  /* RGB dot mask + vignette + dome shadow */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:
      repeating-linear-gradient(
        to right,
        rgba(255, 0, 0, 0.03) 0px,
        rgba(0, 255, 0, 0.03) 1px,
        rgba(0, 0, 255, 0.03) 2px,
        transparent 3px
      ),
      radial-gradient(
        ellipse at center,
        transparent 60%,
        rgba(0, 0, 0, 0.05) 80%,
        rgba(0, 0, 0, 0.1) 100%
      );
    pointer-events: none;
    z-index: 2;
  }

  /* Subtle screen flicker */
  animation: crt-flicker 8s infinite;

  @keyframes crt-flicker {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.98; }
    75% { opacity: 0.995; }
  }
`;

export default CRTEffect;
